import {
  TypographyVariants,
  Typography
} from "@certa/catalyst/components/Typography";
import { Box } from "@certa/catalyst/layouts/Box";
import { Tooltip, TooltipVariants } from "@certa/catalyst/components/Tooltip";

import { CatalystColors } from "@certa/catalyst/constants/styles";
import type { DataObjectIndicator } from "@certa/queries/types/dataObjectsAPIs.types";

import { getIndicatorStyling } from "../../../utils/dataObject/indicators";
import { getIntlBody } from "main/src/js/_helpers/intl-helpers";
import { Stack } from "@certa/catalyst/layouts/Stack";

type DataObjectFieldIndicatorCellProps = {
  indicator: DataObjectIndicator;
  formattedFieldValue: string | number | null;
};

export const DataObjectFieldIndicatorCell = (
  props: DataObjectFieldIndicatorCellProps
) => {
  const { indicator, formattedFieldValue } = props;

  if (!indicator) return null;

  const { backgroundColor, textColor, borderClassName } =
    getIndicatorStyling(indicator);
  const label = getIntlBody(indicator, "label");
  const description = getIntlBody(indicator, "description");

  return (
    <Tooltip
      showArrow={true}
      show={!!description}
      variant={TooltipVariants.LIGHT}
      content={
        <Stack gap="8">
          <Box>{label}</Box>
          <Box color={CatalystColors.NEUTRAL_800}>{description}</Box>
        </Stack>
      }
      maxWidth="20rem"
    >
      <Box
        backgroundColor={backgroundColor as CatalystColors}
        padding="8"
        borderRadius="4"
        width="fit-content"
        dangerouslySetClassName={borderClassName}
      >
        <Typography
          style={{
            whiteSpace: "nowrap"
          }}
          color={textColor as CatalystColors}
          variant={TypographyVariants.OVERLINE_SMALL}
        >
          {formattedFieldValue === 0 ? "0" : formattedFieldValue || "-"}
        </Typography>
      </Box>
    </Tooltip>
  );
};
